import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appCompleteTheWord]'
})
export class CompleteTheWordDirective {

  pressed = false;

  @Output('ngType') initEvent: EventEmitter<any> = new EventEmitter();

  @HostListener('keydown', ['$event']) keyDown(ev) {
    if (!this.pressed) {
      this.pressed = true;
    }
  }
  
  @HostListener('keyup', ['$event']) keyUp(ev) {
    this.pressed = false;
    this.initEvent.emit(ev);
  }

  constructor() { }

}
